/* eslint-disable no-unused-vars */
import React, { useState } from "react";

import ModalCalendarEvent from "../../pages/Calendar/ModalCalendarEvent";
import TaskNew from "../../pages/NovedadDetail/TaskNew";
import TaskListTable from "./taskListTable";
import TaskEdit from "../../pages/NovedadDetail/TaskEdit";

import { useAuth } from "../../context/AuthContext";
import modulos from "../../mocks/modulos";

const TaskList = ({ tasks, setTasks, novedades, novedadId = null, onChange, withPaging, withClientData }) => {
  const { currentUser } = useAuth();
  const [taskSelected, setTaskSelected] = useState(null);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const isAdmin = currentUser.haveAdminAccess(modulos.CALENDAR);
  const isAudit = currentUser.haveAuditAccess(modulos.CALENDAR);
  const handleToggleModal = () => {
    setIsOpenModal(!isOpenModal);
  };

  const handleClickTask = (task) => {
    setTaskSelected(tasks.find((el) => el.id === task.id));
    handleToggleModal();
  };

  const handleClickNewTask = () => {
    setTaskSelected(null);
    handleToggleModal();
  };

  const newTaskUpdated = (updatedTask) => {
    setIsOpenModal(false);
    const elementIndex = tasks.findIndex((task) => task.id === updatedTask.id);
    const orderedTasksNew = [...tasks];
    orderedTasksNew[elementIndex] = updatedTask;
    setTasks(orderedTasksNew);
  };

  const newTaskSubmited = (newTask) => {
    setTasks([...tasks, newTask]);
    setIsOpenModal(false);
    onChange();
  };
  return (
    <>
      <ModalCalendarEvent modalTitle="Detalle Tarea" handleIsOpenModal={isOpenModal} handleToggleModal={handleToggleModal}>
        {taskSelected ? (
          <TaskEdit
            taskSelected={taskSelected}
            newTaskUpdated={newTaskUpdated}
            isAdmin={isAdmin}
            isAudit={isAudit}
            isLider={currentUser.user.Pi.itemId === taskSelected.liderId}
          />
        ) : (
          <TaskNew novedadId={novedadId || (taskSelected && taskSelected.novedadId)} newTaskSubmited={newTaskSubmited} />
        )}
      </ModalCalendarEvent>
      <div>
        <TaskListTable
          tasks={tasks}
          novedades={novedades}
          newTaskUpdated={newTaskUpdated}
          handleClickTask={handleClickTask}
          withPaging={withPaging}
          withClientData={withClientData}
        />
      </div>
      {isAdmin && novedadId && !isAudit ? (
        <div className="todo-list-footer">
          <div className="add-task-btn-wrapper">
            <span className="add-task-btn">
              <button type="button" className="btn btn-primary" onClick={() => handleClickNewTask()}>
                + Crear tarea
              </button>
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default TaskList;
